import React from 'react';
import { Product } from '../types/pricingPage';
import { isStripePrice } from '../utils/products';

interface Props {
    product: Product;
    fillIfMissing: boolean;
    className?: string;
}

export default function ProductImage({ product, fillIfMissing, className }: Props) {
    if (isStripePrice(product) && (product.product.images?.length ?? 0) > 0) {
        return <img src={product.product.images[0]} alt="" className={className} />;
    }
    return fillIfMissing ? <div className={className}></div> : null;
}
